<template>
  <div class="layout-page">
    <bottom></bottom>
    <div class="cat-head shelf-head">
      <ul class="cat-sex">
        <li class="left" :class="{active: getActive() === 'history'}">
          <a @click="toHistory">最近阅读</a>
        </li>
        <li class="right" :class="{active: getActive() === 'shelf'}">
          <a @click="toShelf">我的书架</a>
        </li>
      </ul>
    </div>
    <div id="scroll-div-shelf" class="scroll-list aui-scrollView">
      <div class="shelf-list">
        <template v-if="activated === 'shelf'">
          <books-shelf type="shelf" :show-more="false" :books="shelfList" @remove-book="removeBook"></books-shelf>

          <div v-if="shelfList.length === 0 " class="h400">
            <div class="no_book">
              <p>暂时没有记录</p>
            </div>
          </div>


        </template>
        <template v-if="activated === 'history'">
          <books-shelf type="history" :show-more="false" :books="historyList"></books-shelf>
          <div v-if="historyList.length === 0 " class="h400">
            <div class="no_book">
              <p>暂时没有记录</p>
            </div>
          </div>

        </template>
      </div>
    </div>
  </div>
</template>

<script>
import BooksShelf from '@/components/novel/books-shelf'
import Bottom from '@/components/layer1/bottomIndex'

import shelfService from '../../../services/shelfService'

export default {
  name: 'shelf',
  data () {
    return {
      componentName: '',
      activated: 'history',
      shelfList: [],
      historyList: []
    }
  },
  methods: {
    getActive () {
      return this.activated
    },
    toShelf () {
      this.loadShelf()
      this.activated = 'shelf'
    },
    toHistory () {
      this.loadHistory()
      this.activated = 'history'
    },
    loadShelf () {
      this.shelfList = shelfService.getShelfNovel()
      console.log(this.shelfList.length)
    },
    loadHistory () {
      this.historyList = shelfService.getHistoryNovel()
      console.log(this.historyList.length)
    },
    removeBook (book) {
      // this.$dialog.confirm({
      //   title: '提示',
      //   message: ''
      // })
      shelfService.addShelfNovel(book)
      this.loadShelf()
    }
  },
  components: {
    'books-shelf': BooksShelf,
    bottom: Bottom
  },
  mounted () {
    this.componentName = this.$route.name
    if (
      this.$store.state.pageState[this.componentName] &&
      this.$router.isBack
    ) {
      Object.assign(
        this.$data,
        this.$store.state.pageState[this.$route.name].data
      )
      setTimeout(() => {
        const scrollDiv = document.getElementById('scroll-div-shelf')
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top
      }, 0)
    } else {
      this.loadShelf()
      this.loadHistory()
      // this.toShelf()
      if (this.$route.query.active === 'history') {
        this.toHistory()
      }
    }
    this.$router.isBack = true
  },
  beforeDestroy () {
    const scrollDiv = document.getElementById('scroll-div-shelf')
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>
<style scoped>

@import "../../../assets/css/novel.css";

.h400{ min-height: 10rem;}
.no_book{ width: 10rem; margin: .5rem auto 2rem auto; text-align: center;color: #cecece;}
.no_book p{ font-size: .6rem;display: block; padding-top: 6rem; background: url(../../../assets/images/i11.png) center center no-repeat; background-size: 60px 60px; color: #999;}
</style>



// WEBPACK FOOTER //
// src/pages/layer2/novels/shelf.vue